import { useTrackingFlow } from "@edreamsodigeo/frontend-core";

const skyscannerMktPortals = ["skyscannere", "skyscanner"];

export const useCheckIsSkyscanner = (): boolean => {
  const { getUtmParams } = useTrackingFlow();
  const { utm_source } = getUtmParams();
  return skyscannerMktPortals.includes(utm_source?.toLowerCase());
};
